<template>
  <div class="flex justify-center items-center h-screen">
    <div class="w-4/5 flex flex-col items-center">
      <p class="text-2xl">Carregando...</p>
      <vs-progress indeterminate color="primary">primary</vs-progress>
    </div>
  </div>
</template>

<script>
import serviceStatusNotification from './../../services/statusNotification';
import { updateStoreDataEmpresa } from './../../services/multiple-empresa';

export default {
  mounted() {
    setTimeout(() => {
      updateStoreDataEmpresa();

      const { oldValue } = serviceStatusNotification;
      serviceStatusNotification.updateCountBadge(oldValue);

      this.$router.push('/dashBoard');
    }, 500);
  },
};
</script>
